<template>
  <v-card>
    <div class="py-4 px-4 d-flex justify-center align-center">
      <v-icon large>mdi-currency-usd</v-icon>
      <h2 class="justify-center">Criar saque</h2>

      <v-spacer />
      <v-btn color="primary" icon @click="close">
        <v-icon size="24" color="#ccc">mdi-close</v-icon>
      </v-btn>
    </div>
    <v-form ref="formCreateWithdrawal">
      <v-row cols="12" sm="12" md="12" lg="12" class="ma-0">
        <v-col cols="12" sm="12" md="12" lg="12" class="px-5">
          <label class="ml-1 mb-2 label-details">Valor do saque</label>
          <vuetify-money
              color="black"
              v-bind:outlined="outlined"
              background-color="#F5F5F5"
              placeholder="0.00"
              :rules="[rules.required]"
              required
              hide-details
              style="border: 1px solid #979797; border-radius: 7px; width: 100%;!important;"
              v-model="amount"
              v-bind:options="options"
          ></vuetify-money>
        </v-col>
      </v-row>
    </v-form>
    <v-card-actions>

      <v-row class="ma-0">
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-btn
            height="41"
            class="secondary-button"
            width="100%"
            @click="close()"
            elevation="0"
            target="_blank"
            dark
          >
            Cancelar
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-btn
            height="41"
            width="100%"
            class="primary-button"
            elevation="0"
            dark
            @click="criarSaque()"
          >
            <span>Criar saque</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>


  </v-card>
</template>

<style scoped>
.label {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.2px;
  color: #232021;
}
</style>

<script scoped>
 import Vue from "vue";

export default {
  name: "CreateWithdrawal",

  props: {

  },

  data: () => ({
    loading: false,
    outlined: true,
    amount: null,
    options: {
      locale: "pt-BR",
      prefix: "R$",
      suffix: "",
      length: 11,
      precision: 2
    },
    rules: {
      required: (value) => !!value || "Campo requerido.",
      min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
    },
   }),

  computed: {},

  methods: {
    criarSaque(){
      if (!this.$refs.formCreateWithdrawal.validate()) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Digite o valor do saque",
          trace: null,
        });
        return
      }
      this.$emit("criarSaque", this.amount);
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>
